import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiShield, FiSearch, FiSmartphone, FiTarget, FiMapPin } = FiIcons;

const USP = () => {
  const features = [
    {
      icon: FiEdit3,
      title: 'Direct response copywriting',
      description: 'Written to convert, not just inform'
    },
    {
      icon: FiShield,
      title: 'Trust-first structure',
      description: 'Builds credibility before asking for contact'
    },
    {
      icon: FiSearch,
      title: 'Local SEO foundations',
      description: 'Optimised for your service area searches'
    },
    {
      icon: FiSmartphone,
      title: 'Mobile-first conversion paths',
      description: 'Designed for instant calls and enquiries'
    },
    {
      icon: FiTarget,
      title: 'Single clear goal: enquiries',
      description: 'No distractions, just results'
    },
    {
      icon: FiMapPin,
      title: 'Tailored to trade services',
      description: 'Built specifically for your industry and area'
    }
  ];

  return (
    <section id="usp" className="py-20 bg-gradient-to-br from-black to-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Built to perform, not just look nice
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Every element is strategically designed to turn visitors into customers, 
            not just showcase your services.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-all duration-200"
            >
              <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-3 rounded-lg w-fit mb-4">
                <SafeIcon icon={feature.icon} className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-white font-semibold mb-2">{feature.title}</h3>
              <p className="text-white/70">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USP;